import React from 'react';
import NavBarLap from './navBarLap';
import GrillLap from './grillLap';
import FooterLap from './footerLap';
import './laptop.css'




function laptop() {
  return (
    <div className="Laptop">
    <NavBarLap />
    <GrillLap />
    <FooterLap />
    </div>
  );
}

export default laptop;